import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import baoCaoTuTapReducer from './slices/baoCaoTuTap';
import baoCaoTuHocReducer from './slices/baoCaoTuHoc';
import bqlSystemManageReducer from './slices/bqlSystemManage';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    systemManage: bqlSystemManageReducer,
    customization: customizationReducer,
    result: baoCaoTuTapReducer,
    baoCaoTuHoc: baoCaoTuHocReducer
});

export default reducer;
